import MONSTRO_6 from "url:../sprites/coelhoso.png";
import SOM_3 from "url:../sfx/huuooo.m4a";

export default {
  attack: 2,
  life: 9,
  speed: 6,
  agility: 7,
  weapon: 2,
  armor: 1,
  image: MONSTRO_6,
  sound: SOM_3,
};
